module.exports = __webpack_public_path__ + "static/img/topabout.9b929207.jpg";